

exports.__esModule = true;
exports.$SidebarRoute = undefined;

require('xo-wallet-components/src/add-bank/route');

require('xo-member-components/src/select-shipping/add-shipping/route');

require('xo-member-components/src/select-shipping/delete-shipping/route');

require('xo-member-components/src/select-shipping/update-shipping/route');

require('pages/xo-shipping/route');

require('pages/xo-sidebar-add-shipping/route');

require('pages/xo-sidebar-add-card/route');

require('pages/xo-sidebar-add-bank/route');

require('pages/xo-sidebar-currency-conversion/route');

require('pages/xo-sidebar-installment-options/route');

require('pages/xo-wallet/route');

require('pages/xo-add-card/route');

require('./directive');

require('pages/xo-sidebar-manage-wallet/route');

require('pages/xo-sidebar-update-card/route');

require('pages/xo-sidebar-add-new/route');

var _index = require('squid/index');

/* dynamic-import */
/* dynamic-import */
/* dynamic-import */
/* dynamic-import */
/* dynamic-import */
/* dynamic-import */
/* dynamic-import */
var $SidebarRoute = exports.$SidebarRoute = _index.$Route.extend('$SidebarRoute', {
    path: 'sidebar',
    directive: 'xo-sidebar',
    children: [{
        name: '$SidebarShippingRoute',
        attributes: {
            token: 'props.token',
            'back-uri': 'props.backUri',
            'shipping-change-feature': 'props.shippingChangeFeature'
        },
        lazyRoute: 'pages/xo-shipping/route',
        slug: 'shipping'
    }, {
        name: '$SidebarAddShippingRoute',
        attributes: {
            token: 'props.token',
            'back-uri': 'props.backUri',
            'shipping-change-feature': 'props.shippingChangeFeature'
        },
        lazyRoute: 'pages/xo-sidebar-add-shipping/route',
        slug: 'sidebarAddShipping'
    }, {
        name: '$SidebarAddCardRoute',
        attributes: {
            token: 'props.token',
            promotion: 'props.promotion',
            'back-uri': 'props.backUri',
            'done-uri': 'props.doneUri'
        },
        lazyRoute: 'pages/xo-sidebar-add-card/route',
        slug: 'sidebarAddCard'
    }, {
        name: '$SidebarAddBankRoute',
        attributes: {
            token: 'props.token'
        },
        lazyRoute: 'pages/xo-sidebar-add-bank/route',
        slug: 'sidebarAddBank'
    }, {
        name: '$SidebarWalletRoute',
        props: function props() {
            return {
                token: this.props.token,
                promotion: this.props.promotion,
                installment: this.props.installment
            };
        },
        config: function config() {
            return {
                heading: 'asideHeader.fundingInstruments',
                subHeading: 'asideHeader.fundingInstrumentsSubHead',
                addRoute: 'checkout.review.sidebar.sidebarAddCard.addCardFlow.addCard'
            };
        },

        lazyRoute: 'pages/xo-wallet/route',
        slug: 'wallet'
    }, {
        name: '$AddBankFlowRoute',
        attributes: {
            token: 'props.token',
            'parent-callbacks': 'callbacks'
        },
        lazyRoute: 'xo-wallet-components/src/add-bank/route',
        slug: 'bank'
    }, {
        name: '$AddCardPageRoute',
        attributes: {
            token: 'props.token',
            'parent-callbacks': 'callbacks'
        },
        lazyRoute: 'pages/xo-add-card/route',
        slug: 'pageAddCard'
    }, {
        name: '$AddShippingRoute',
        attributes: {
            token: 'props.token',
            'parent-callbacks': 'callbacks',
            'done-fn': 'callbacks.done',
            'back-uri': 'props.backUri',
            sidebar: 'sidebar',
            update: 'props.update',
            'shipping-change-feature': 'props.shippingChangeFeature'
        },
        lazyRoute: 'xo-member-components/src/select-shipping/add-shipping/route',
        slug: 'addShipping'
    }, {
        name: '$UpdateShippingRoute',
        attributes: {
            token: 'props.token',
            'parent-callbacks': 'callbacks',
            'done-fn': 'callbacks.done',
            'shipping-change-feature': 'props.shippingChangeFeature',
            sidebar: 'sidebar'
        },
        lazyRoute: 'xo-member-components/src/select-shipping/update-shipping/route',
        slug: 'updateShipping'
    }, {
        name: '$DeleteShippingRoute',
        attributes: {
            token: 'props.token',
            'parent-callbacks': 'callbacks',
            sidebar: 'sidebar'
        },
        lazyRoute: 'xo-member-components/src/select-shipping/delete-shipping/route',
        slug: 'deleteShipping'
    }, {
        name: '$SidebarCurrencyConversionRoute',
        attributes: {
            token: 'props.token'
        },
        lazyRoute: 'pages/xo-sidebar-currency-conversion/route',
        slug: 'currencyConversion'
    }, {
        name: '$SidebarInstallmentOptionsRoute',
        attributes: {
            token: 'props.token'
        },
        lazyRoute: 'pages/xo-sidebar-installment-options/route',
        slug: 'installmentOptions'
    }, {
        name: '$SidebarManageWalletRoute',
        props: function props() {
            return {
                token: this.token
            };
        },

        lazyRoute: 'pages/xo-sidebar-manage-wallet/route',
        slug: 'sidebarManageWallet'
    }, {
        name: '$SidebarUpdateCardRoute',
        props: function props() {
            return {
                token: this.token,
                backUri: this.props.backUri,
                doneUri: this.props.doneUri
            };
        },

        lazyRoute: 'pages/xo-sidebar-update-card/route',
        slug: 'sidebarUpdateCard'
    }, {
        name: '$SidebarAddNewRoute',
        props: function props() {
            return {
                token: this.props.token,
                backUri: this.props.backUri,
                doneUri: this.props.doneUri,
                promotion: this.props.promotion,
                'show-cancel': this.props.showCancel,
                'parent-callbacks': this.props.callbacks
            };
        },

        lazyRoute: 'pages/xo-sidebar-add-new/route',
        slug: 'sidebarAddNew'
    }]
}); /* dynamic-import */
/* dynamic-import */
/* dynamic-import */
/* dynamic-import */
/* dynamic-import */
/* dynamic-import */
/* dynamic-import */
/* dynamic-import */


angular.value("$SidebarRoute", $SidebarRoute);
_index.$Route;


//////////////////
// WEBPACK FOOTER
// ./pages/xo-sidebar/route.js
// module id = ./pages/xo-sidebar/route.js
// module chunks = 0